<template>
  <!-- footer -->
  <div id="footerWrap" class="footer">
    <button class="btn_top" @click="moveTop()">TOP</button>

    <div class="footer_cont">
      <!-- <div
        class="selectbox sel_family"
        v-for="(item, idx) in familySites"
        :key="`footer-select-key-${idx}`"
      >
        <label for="select">{{ item.label }}</label>
        <select id="select" @change="goFamily($event)">
          <option disabled selected hidden>{{ item.label }}</option>
          <option
            v-for="(menu, idx) in item.options"
            :value="menu.path"
            :key="`footer-select-option-key-${idx}`"
          >
            {{ menu.name }}
          </option>
        </select>
      </div> -->

      <div class="footer_link">
        <a :href="$t('main[0].path')" class="footer_logo"
          ><img
            :src="`${resources}img/logo-footer-kop.png`"
            alt="한국오션플랫폼"
        /></a>
        <div class="link_wrap">
          <i18n
            tag="router-link"
            v-for="(menu, idx) in $t('footer.list')"
            :path="`footer.list[${idx}].name`"
            :key="`footer-list-${idx}`"
            :to="menu.path"
            :title="menu.title || null"
            :target="menu.target || null"
            :rel="menu.target === '_blank' ? 'noreferrer noopener' : null"
          >
            <br />
          </i18n>
        </div>
        <div class="link_wrap2">
          <!-- 2024-03-20 사용하지 않는 메일로 삭제
          <span
            >일반문의 :
            <a href="mailto:hspcc_inquiry@hansunge.co.kr"
              >hspcc_inquiry@hansunge.co.kr</a
            ></span
          > -->
          <span
            >영업문의 : <a href="mailto:work@kop.co.kr">work@kop.co.kr</a></span
          >
          <span
            >채용문의 : <a href="mailto:insa@kop.co.kr">insa@kop.co.kr</a></span
          >
        </div>
      </div>

      <div class="copyright">
        <p>COPYRIGHTⓒ KOP.ALL RIGHTS RESERVED</p>
      </div>
      <div class="btn_biz">
        <a
          href="/files/pdf/kop_brochure.pdf"
          target="_blank"
          rel="noreferrer noopener"
          class="btn_m_download"
          >회사소개서 다운로드</a
        >
        <a
          href="https://epro.lsyesco.com/spLogin.do"
          target="_blank"
          rel="noreferrer noopener"
          class="btn_m_contract"
          >전자계약(협력사 포털)</a
        >
      </div>
    </div>
  </div>
  <!-- footer -->
</template>

<script>
import mixin from '@/mixins';

/**
 * @module components/mo/Bottom
 * @vue-computed {Array} familySites - 패밀리 사이트 select option
 */
export default {
  mixins  : [mixin],
  computed: {
    familySites() {
      return this.$t('footer.select');
    }
  },
  methods: {
    /**
     * 패밀리 사이트 이동 함수
     */
    goFamily(e) {
      window.open(e.target.value);

      if (e.target.options.length > 0) {
        e.target.value = e.target.options[0].textContent;
      }
    },
    /**
     * 스크롤 0으로 이동
     */
    moveTop() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="scss" scoped></style>
